import { gql } from '@apollo/client';

export const UPDATE_ROL = gql`
    mutation UpdateRol(
        $id: Int!
        $descripcion: String!
        $idFuncion: Int!
        $activo: Boolean!
        $idTipoProfesional: Int!
        $listaPantallas: [PantallaRolInput!]!
        $listaNotificaciones: [NotificacionRolInput!]!
        $listaKpis: [KpiRolModelInput!]!
        $listaRolesNoCompatibles: [RolNoCompatibleInput!]!
        $listaConsultaRol: [ConsultaRolEntradaInput!]!
    ) {
        updateRol(
            model: {
                id: $id
                descripcion: $descripcion
                idFuncion: $idFuncion
                idTipoProfesional: $idTipoProfesional
                activo: $activo
                listaPantallas: $listaPantallas
                listaNotificaciones: $listaNotificaciones
                listaKpis: $listaKpis
                listaRolesNoCompatibles: $listaRolesNoCompatibles
                listaConsultaRol: $listaConsultaRol
            }
        ) {
            success
            error
            valorEsperado
        }
    }
`;